$(document).ready(function(){
  $("body").on("click",".news__stars-item--rate",function(){
      parent = $(this).closest('.news__stars');
      $.post("/module/postrate",{
        "post_id": $(this).closest("[data-post]").attr("data-post"),
        "rate": $(this).attr('data-value'),
        "_token": window.Laravel.csrfToken
      },function(response){
        parent.find('.news__stars-item--active').removeClass('news__stars-item--active');
        if(response.rate>0)
          parent.find('.news__stars-item').eq(0).addClass('news__stars-item--active');
        for(var i=1;i<4;i++){
          if(response.rate>=i+1)
            parent.find('.news__stars-item').eq(i).addClass('news__stars-item--active');
        }
        if(response.rate==5)
          parent.find('.news__stars-item').eq(4).addClass('news__stars-item--active');
      });
  });
});
